module.exports = __webpack_public_path__ + "4a435b0d7fe20c216656f90fbe1c98f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/tiyan/tiyan5.jpg
// module id = 1234
// module chunks = 0